<template>
  <AppInput
    v-model='isPrivacyPolicyAccepted'
    class='privacy-policy-confirmation'
    type='checkbox'
    :label='privacyPolicyLabel'
    :error='privacyPolicyError'
    @input="$emit('input')"
  />
</template>

<script setup>
import { computed, watch } from 'vue';
import AppInput from './app_input';
import { prepared } from '@/helpers/i18n';

const props = defineProps({
  privacyUrl: { type: String, required: true }
});

const emit = defineEmits(['input']);
const tp = prepared('frontend.privacy_policy');

const isPrivacyPolicyAccepted = defineModel('isPrivacyPolicyAccepted', { type: Boolean });
const isPrivacyPolicyError = defineModel('isPrivacyPolicyError', { type: Boolean });

const privacyPolicyLabel = tp('label', { privacy_policy_url: props.privacyUrl });

const privacyPolicyError = computed(() => (
  !isPrivacyPolicyAccepted.value && isPrivacyPolicyError.value ?
    tp('error') :
    null
));

watch(isPrivacyPolicyAccepted, () => {
  if (!isPrivacyPolicyAccepted.value) {
    isPrivacyPolicyError.value = false;
  }
});

defineExpose({
  privacyPolicyLabel,
  privacyPolicyError,
  clear() {
    isPrivacyPolicyAccepted.value = false;
    isPrivacyPolicyError.value = false;
  }
});
</script>

<style scoped lang='sass'>
@import 'app/packs/stylesheets/mixins/typography'

.privacy-policy-confirmation ::v-deep(label span)
  +p5
</style>
